import { render } from "./authLayout.vue?vue&type=template&id=dc4cc48e&scoped=true"
import script from "./authLayout.vue?vue&type=script&lang=js"
export * from "./authLayout.vue?vue&type=script&lang=js"

import "./authLayout.vue?vue&type=style&index=0&id=dc4cc48e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4cc48e"]])

export default __exports__